if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
        // Resume all autoplaying videos when modal closes
        this.resumeVideos();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      resumeVideos() {
        // Find all videos in product media containers and resume playback
        setTimeout(() => {
          const videos = document.querySelectorAll('.product-media-container video');
          videos.forEach(video => {
            if (video.paused && video.hasAttribute('autoplay')) {
              video.play().catch(() => {
                // Silently handle any autoplay restrictions
              });
            }
          });

          // Handle external videos (YouTube/Vimeo iframes)
          const iframes = document.querySelectorAll('.product-media-container iframe');
          iframes.forEach(iframe => {
            if (iframe.src.includes('autoplay=1')) {
              // Reload iframe to restart autoplay
              const src = iframe.src;
              iframe.src = src;
            }
          });
        }, 100);
      }
    }
  );
}
